import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import {
  BaseButton,
  PrimaryButton,
  rubikTypographyStyles,
} from '../../../shared/ui';

type GoalIntroContinueButtonProps = {
  canSubmit: boolean;
  onContinue: () => void;
};

type GoalIntroSkipButtonProps = {
  isDisabled?: boolean;
  onSkip: () => void;
};

const ContinueButton = styled(PrimaryButton).attrs({
  'data-ui': 'registration-goals-goal-intro-continue',
})<{ $isDisabled: boolean }>`
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.4 : 1)};
`;

const SkipButton = styled(BaseButton).attrs({
  'data-ui': 'registration-goals-goal-intro-skip',
})`
  ${rubikTypographyStyles};
  font-size: ${({ theme }) => theme.scale.px(15)};
  font-weight: 400;
  line-height: 1.25;
  text-decoration: underline;
`;

export function GoalIntroContinueButton({
  canSubmit,
  onContinue,
}: GoalIntroContinueButtonProps) {
  const { t } = useTranslation();

  return (
    <ContinueButton
      $isDisabled={!canSubmit}
      disabled={!canSubmit}
      type="button"
      onClick={onContinue}
    >
      {t('registrationGoals.cta')}
    </ContinueButton>
  );
}

export function GoalIntroSkipButton({
  isDisabled = false,
  onSkip,
}: GoalIntroSkipButtonProps) {
  const { t } = useTranslation();

  return (
    <SkipButton disabled={isDisabled} type="button" onClick={onSkip}>
      {t('registrationGoals.skip')}
    </SkipButton>
  );
}
